import Blockly from 'blockly'
import 'blockly/python'

let blockJson = {
  type: 'start_on_boot',
  message0: '%{BKY_CUSTOM_START_ON_BOOT}',
  args0: [
    {
      type: 'field_image',
      src: 'https://i.ibb.co/LtKWN77/flag-checkered-solid.png',
      width: 30,
      height: 30,
      alt: '*'
    },
    {
      type: 'input_dummy'
    },
    {
      type: 'input_statement',
      name: 'start_statments'
    }
  ],
  style: 'start_blocks',
  tooltip: '%{BKY_CUSTOM_START_ON_BOOT_TOOLTIP}',
  helpUrl: ''
}

Blockly.Blocks['start_on_boot'] = {
  init: function () {
    this.jsonInit(blockJson)
  }
}

Blockly.Python['start_on_boot'] = function (block) {
  let statements_start = Blockly.Python.statementToCode(
    block,
    'start_statments'
  )
  let code = _.join(
    _.map(_.split(statements_start, '\n'), (state) =>
      state.replace(Blockly.Python.INDENT, '')
    ),
    '\n'
  )
  code = code.replace(/\n\n/g, '\n')
  return code
}
